import styled from "styled-components";

export const ButtonContainer = styled.button`
  color: ${(p) => (p.$textColor ? p.$textColor : "#07111f")};
  font-family: var(--font-family-primary);
  font-size: 16px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.01em;
  cursor: pointer;
  border: 1px solid
    ${(p) => (p.$background ? "transparent" : "var(--color-line-strong)")};
  outline: none;
  position: relative;
  overflow: hidden;

  display: inline-flex;
  flex-direction: row;
  gap: 8px;
  min-height: 44px;
  padding: 12px 22px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: var(--radius-pill);
  background: ${(p) =>
    p.$background
      ? p.$background
      : "linear-gradient(180deg, var(--color-brand-500) 0%, var(--color-brand-600) 100%)"};
  box-shadow: ${(p) =>
    p.$background ? "var(--shadow-micro)" : "var(--shadow-cta)"};
  flex-shrink: 0;
  transition:
    transform 180ms var(--ease-snappy),
    box-shadow 180ms var(--ease-snappy),
    filter 180ms var(--ease-snappy);

  &::before {
    content: "";
    position: absolute;
    inset: 1px;
    border-radius: inherit;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.16) 0%,
      rgba(255, 255, 255, 0) 46%
    );
    pointer-events: none;
  }

  &:hover {
    transform: translateY(-2px);
    filter: brightness(1.03);
  }

  &:active {
    transform: translateY(0px);
    filter: brightness(0.97);
  }

  &:disabled {
    cursor: not-allowed;
    transform: none !important;
    opacity: ${(p) => (p.$opacity ? 0.75 : 0.55)};
    box-shadow: none;
    filter: none;
  }
`;
